export const GET_USER_EMAIL_AVAILABILITY = 'GET_USER_EMAIL_AVAILABILITY'
export const SET_USER_EMAIL_AVAILABILITY = 'SET_USER_EMAIL_AVAILABILITY'
export const SET_USER_EMAIL_AVAILABILITY_PROCESSING = 'SET_USER_EMAIL_AVAILABILITY_PROCESSING'
export const RESET_USER_EMAIL_AVAILABILITY = 'RESET_USER_EMAIL_AVAILABILITY'

export function getUserEmailAvailability (email) {
  return {
    type: GET_USER_EMAIL_AVAILABILITY,
    payload: email,
  }
}

export function setUserEmailAvailability (isAvailable) {
  return {
    type: SET_USER_EMAIL_AVAILABILITY,
    payload: isAvailable,
  }
}

export function setUserEmailAvailabilityProcessing (isProcessing) {
  return {
    type: SET_USER_EMAIL_AVAILABILITY_PROCESSING,
    payload: isProcessing,
  }
}

export function resetUserEmailAvailability () {
  return {
    type: RESET_USER_EMAIL_AVAILABILITY,
  }
}
